"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    divider: {
      margin: 0,
      height: 1,
      border: 0,
      backgroundColor: theme.divider.color
    }
  };
};